import { useGetUserApi } from '@liquidbudget/common';
import { RefreshCcw } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogTrigger } from '../ui/dialog';
import { BankImportDialogSetup } from './bank-import-dialog-setup';
import { BankImportDialogTable } from './bank-import-dialog-table';

export const BankImportDialog = () => {
  const [open, setOpen] = useState(false);
  const { data: user } = useGetUserApi();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="flex-grow justify-items-start" variant="outline">
          <RefreshCcw className="mr-2 h-4 w-4" />
          <span> Import</span>
        </Button>
      </DialogTrigger>
      {user?.simpleFinEnabled ? <BankImportDialogTable /> : <BankImportDialogSetup setOpen={setOpen} />}
    </Dialog>
  );
};
